import { cn } from "@/lib/utils";
import { Icon } from "./icon";

// Invoice/document visibility indicator, introduced in the design's invoice
// lifecycle iteration (chat1.md) and specified in docs/design-system.md §4:
// draft = eye-off "Not visible to club"; issued/paid = eye "Visible to club".
export interface VisibilityTagProps {
  visible: boolean;
  /** Localised labels (callers pass translated strings). */
  shownLabel: string;
  hiddenLabel: string;
}

export function VisibilityTag({ visible, shownLabel, hiddenLabel }: VisibilityTagProps) {
  return (
    <span className={cn("vis-tag", visible ? "shown" : "hidden")}>
      <Icon name={visible ? "eye" : "eyeOff"} size={14} />
      {visible ? shownLabel : hiddenLabel}
    </span>
  );
}
